import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6fa8265c")

_pushScopeId("data-v-6fa8265c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("心拍設定を編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "pr-4 mt-4 text-sm text-gray-600"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "pr-4 mt-4 text-sm font-medium text-gray-600" }, " 対象生徒 ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "pr-4 mt-4 text-sm text-red-500" }, " デバイスIDが登録されている生徒がいません。 ", -1)
const _hoisted_9 = { class: "flex justify-end gap-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 削除 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 変更を保存 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_ms_student_picker = _resolveComponent("ms-student-picker")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "タイトル",
          name: "title",
          type: "text",
          value: _ctx.title,
          placeholder: "タイトルを入力してください",
          invalid: !_ctx.validTitle,
          "invalid-message": "タイトルは1文字以上入力してください",
          entered: _ctx.titleEntered,
          onEnter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.titleEntered = true)),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.title = $event))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "心拍数の上限",
          name: "threshold",
          type: "number",
          value: _ctx.threshold,
          placeholder: "心拍数の上限を入力してください",
          invalid: !_ctx.validThreshold,
          "invalid-message": "値は1以上に設定してください。",
          entered: _ctx.thresholdEntered,
          onEnter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.thresholdEntered = true)),
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.threshold = $event))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alertLevels, (level, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: "w-3/4 mx-auto mb-6"
        }, [
          _createVNode(_component_m_text_field, {
            label: `${_ctx.getLevelTitle(level.label)}までの継続時間（秒数）`,
            name: `duration-${index}`,
            type: "number",
            value: level.minimumDurationSec,
            placeholder: 
            `${_ctx.getLevelTitle(level.label)}までの秒数を入力してください`
          ,
            invalid: _ctx.invalidLevelIndexes.includes(index),
            "invalid-message": 
            `値は1以上または${_ctx.maxSeconds}以下に設定してください。`
          ,
            entered: _ctx.enteredIndexes.includes(index),
            onEnter: ($event: any) => (_ctx.enteredIndexes.push(index)),
            onInput: ($event: any) => (level.minimumDurationSec = $event)
          }, null, 8, ["label", "name", "value", "placeholder", "invalid", "invalid-message", "entered", "onEnter", "onInput"])
        ]))
      }), 128)),
      _createVNode("div", _hoisted_4, [
        (!_ctx.allStudentsFetched)
          ? (_openBlock(), _createBlock("p", _hoisted_5, " 生徒情報読み込み中... "))
          : (_ctx.students.length > 0)
            ? (_openBlock(), _createBlock(_component_ms_student_picker, {
                key: 1,
                "default-student-ids": _ctx.defaultStudentIds,
                "target-students": _ctx.students,
                onUpdate: _ctx.updateSelectedStudents
              }, null, 8, ["default-student-ids", "target-students", "onUpdate"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8
              ]))
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_m_button, {
          color: "red-400",
          "hover-color": "red-500",
          outline: "",
          onClick: _ctx.executeDelete
        }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validInput,
          onClick: _ctx.execute
        }, {
          default: _withId(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})